export interface SlidePreviewSelectionState {
  itemId: string | null
  leftNeighborId: string | null
  rightNeighborId: string | null
  slideDelta: number
  minDelta: number
  maxDelta: number
}

export interface TimelineItemSlidePreview {
  activeItemId: string | null
  primaryLeftNeighborId: string | null
  primaryRightNeighborId: string | null
  slideDelta: number
  minDelta: number
  maxDelta: number
  isPrimary: boolean
  isLeftNeighbor: boolean
  isRightNeighbor: boolean
}

export function selectTimelineItemSlidePreview(
  state: SlidePreviewSelectionState,
  itemId: string,
): TimelineItemSlidePreview {
  const isPrimary = state.itemId === itemId
  const isLeftNeighbor = state.leftNeighborId === itemId
  const isRightNeighbor = state.rightNeighborId === itemId
  const isRelated = isPrimary || isLeftNeighbor || isRightNeighbor

  return {
    activeItemId: state.itemId,
    primaryLeftNeighborId: isPrimary ? state.leftNeighborId : null,
    primaryRightNeighborId: isPrimary ? state.rightNeighborId : null,
    slideDelta: isRelated ? state.slideDelta : 0,
    minDelta: state.minDelta,
    maxDelta: state.maxDelta,
    isPrimary,
    isLeftNeighbor,
    isRightNeighbor,
  }
}